/**
 * @generated SignedSource<<056a479a4ed1d8e6497dc8d606e08078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateKeyFeaturesSectionRelayFragment$data = {
  readonly keyFeatures: ReadonlyArray<{
    readonly name: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "templateKeyFeaturesSectionRelayFragment";
};
export type templateKeyFeaturesSectionRelayFragment$key = {
  readonly " $data"?: templateKeyFeaturesSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateKeyFeaturesSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateKeyFeaturesSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTaxonomyFeature",
      "kind": "LinkedField",
      "name": "keyFeatures",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "ca513b85820bd9e40ad8bee5602e1221";

export default node;
